import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { signInWithGoogle } from './firebase';
import './NavBar.css';

function NavBar() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div
      className={`hamburger-menu ${menuOpen ? 'open' : ''}`}
      onMouseEnter={() => setMenuOpen(true)}
      onMouseLeave={() => setMenuOpen(false)}
    >
      <button
        className="hamburger-button"
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Menu"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>
      <nav className={`hamburger-nav ${menuOpen ? 'visible' : ''}`}>
        <Link to="/" className="nav-item">Home</Link>
        <Link to="/about" className="nav-item">About</Link>
        <Link to="/features" className="nav-item">Features</Link>
        <Link to="/tools" className="nav-item">Tools</Link>
        <Link to="/projects" className="nav-item">Projects</Link>
        <Link to="/docs" className="nav-item">Docs</Link>
        <Link to="/whitepaper" className="nav-item">Whitepaper</Link>
        <Link to="/blog" className="nav-item">Blog</Link>
        <button className="nav-item nav-cta-button" onClick={signInWithGoogle}>
          Login
        </button>
      </nav>
    </div>
  );
}

export default NavBar;
